'use client';

import { motion } from 'framer-motion';
import Skeleton from './LoadingSkeleton';

export const OurProgramsLoadingSkeleton = () => {
  return (
    <motion.section 
      className="py-20"
      style={{ backgroundColor: '#F5F6FF' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header Skeleton */}
        <div className="text-center mb-16">
          <Skeleton className="h-4 w-32 mx-auto mb-2" style={{ backgroundColor: '#4670BF' }} />
          <Skeleton className="h-12 w-48 mx-auto" style={{ backgroundColor: '#21272A' }} />
        </div>

        {/* Programs Grid Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Generate 3 program card skeletons */}
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="group relative rounded-xl overflow-hidden shadow-lg">
              {/* Program Image Skeleton */}
              <Skeleton 
                className="aspect-[4/3] w-full" 
                style={{ 
                  background: 'linear-gradient(135deg, #B5CEFC 0%, #81A3F8 100%)'
                }} 
              />
              
              {/* Overlay Skeleton */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end">
                <div className="p-6 w-full">
                  <Skeleton className="h-6 w-3/4 mb-2" style={{ backgroundColor: '#FFFFFF' }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};
